import { useReferrals } from "../../services/dashboard";

const avatarPalette = [
  { bg: "#cce7ef", text: "#011b21" },
  { bg: "#adefe8", text: "#00201e" },
  { bg: "#ffdbc7", text: "#311300" },
  { bg: "#e3e3d9", text: "#1a1c16" },
  { bg: "#b1cbd3", text: "#011b21" },
];

const imgBadgeGreen  = "https://www.figma.com/api/mcp/asset/14701941-33a7-4f8b-b2f3-b8e1e75fcdda";
const imgBadgeOrange = "https://www.figma.com/api/mcp/asset/0a378590-382e-4d19-9e7f-21011f48656c";

const getInitials = (name: string) =>
  name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

const RecentReferrals = () => {
  const { data: referrals, isLoading, isError } = useReferrals();

  if (isLoading) {
    return (
      <div className="bg-white rounded-[8px] w-full xl:flex-1 min-w-0 px-6 py-6" style={{ boxShadow: "0px 1px 1px rgba(0,0,0,0.05)" }}>
        <p className="text-[13px] text-content-label">Loading…</p>
      </div>
    );
  }

  if (isError) return null;

  if (!referrals?.length) {
    return (
      <div
        className="bg-white rounded-[8px] overflow-hidden flex flex-col w-full xl:flex-1 min-w-0"
        style={{ boxShadow: "0px 1px 1px rgba(0,0,0,0.05)" }}
      >
        <div className="px-6 py-6 bg-surface-input">
          <h2 className="text-[18px] font-semibold text-content-heading">Recent Referrals</h2>
        </div>
        <p className="px-6 py-6 text-[14px] text-content-label">No referrals yet.</p>
      </div>
    );
  }

  return (
    <div
      className="bg-white rounded-[8px] overflow-hidden flex flex-col w-full xl:flex-1 min-w-0"
      style={{ boxShadow: "0px 1px 1px rgba(0,0,0,0.05)" }}
    >
      {/* Card header */}
      <div className="px-6 py-6 bg-surface-input">
        <h2 className="text-[18px] font-semibold text-content-heading">
          Recent Referrals
        </h2>
      </div>

      {/* Referral list */}
      <div className="flex flex-col gap-6 p-6">
        {referrals.map((r, i) => {
          const { bg, text } = avatarPalette[i % avatarPalette.length];
          const isPending = r.status === "pending";
          const badge = isPending ? imgBadgeOrange : imgBadgeGreen;
          const statusText = isPending
            ? "Pending"
            : `+${r.referee_points_awarded.toLocaleString()} pts`;
          const statusColor = isPending ? "#e97300" : "#246863";

          return (
            <div key={r.referral_id} className="flex items-center justify-between gap-4">
              {/* Avatar + info */}
              <div className="flex items-center gap-4 min-w-0">
                <div className="relative shrink-0">
                  <div
                    className="w-10 h-10 rounded-[12px] border-2 border-[#fafaf0] flex items-center justify-center text-[13px] font-semibold"
                    style={{ backgroundColor: bg, color: text }}
                  >
                    {getInitials(r.referee_name)}
                  </div>
                  <img
                    src={badge}
                    alt=""
                    className="absolute -bottom-1 -right-1 w-[12px] h-[12px]"
                  />
                </div>
                <div className="flex flex-col gap-1 min-w-0">
                  <p
                    className="text-[14px] leading-none text-content-heading"
                    style={{ fontFamily: "Inter, Montserrat, sans-serif" }}
                  >
                    <span className="font-semibold">{r.referrer_name}</span>
                    {" "}
                    <span className="font-normal text-content-label">referred</span>
                    {" "}
                    <span className="font-semibold">{r.referee_name}</span>
                  </p>
                  <p
                    className="text-[8px] font-semibold uppercase tracking-wide text-content-label"
                  >
                    {formatDate(r.created_at)}
                  </p>
                </div>
              </div>

              {/* Status */}
              <span
                className="text-[12px] font-medium shrink-0"
                style={{ color: statusColor }}
              >
                {statusText}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentReferrals;
